export default __webpack_public_path__ + "static/media/class_v_vi_m.d5eb5172.png";